/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const sendSmsRequestRequestSchema = z
	.object({
		country_code: z.string().min(1).max(4).optional().default("+7"),
		phone: z.string().min(1).max(20),
		group_external_id: z.uuid(),
		message: z.string().min(1),
	})
	.describe("Сериализатор запроса на отправку SMS.");
